import {userApi} from './../../api';
import App from '../../app';
import { Award, Member, Rank, AdminRoles, Post} from '../../interfaces';
import core from '~/core'

const rw_categories = "S-3;S-4;S-8".split(';');
const rw_name = "FLEET COMMAND;HIGH COMMAND".split(';');

export const collection = App.Collection<Member>()(collection => ({

}))
export const state = {
    id: App.State<string>(""),
    name: App.State<string>(""),
    administrativeRoles: App.State<Array<{name?: string, category?: string}>>([]),
    discord: App.State<{name?: string, id?: string|number}>({}),
    imgUrl: App.State<string>(""),
    squadrons: App.State<Array<{name?: string, parent?: string, type?: string}>>([]),
    onboard: App.State<boolean>(false).persist('events_onboarded').key('events_onboarded'),
    
}
export const computed = {
    canCreateEvent: App.Computed<boolean>((): boolean => {

        const catCorrect = state.administrativeRoles.value.findIndex(role => 
            rw_categories.findIndex((approved) => role.category.toUpperCase().trim() === approved.toUpperCase().trim()) > -1 
        ) > -1 
        const nameCorrect = state.administrativeRoles.value.findIndex(role => 
            rw_name.findIndex((approved) => role.name.toUpperCase() === approved.toUpperCase().trim()) > -1 
        ) > -1
        const squadCorrect = state.squadrons.value.findIndex(squad => squad.type === 'COMMAND') > -1
        return catCorrect || nameCorrect || squadCorrect;
    }),
    isS8OrAdmin: App.Computed<boolean>((): boolean => {
        return state.administrativeRoles.value.findIndex(role => 
            role.category.toUpperCase().trim() === "S-8"
        ) >= 0 
    }),
    
    
    // currentPlayerId: App.Computed<Promise<string>>(async () => (await userApi.getId()))
}
export {

}